import { jsx as _jsx } from "react/jsx-runtime";
import { defaultPartialDataGridProps, StripedDataGrid } from '../../factories/DataGrid';
import { AsyncImageCell } from './AsyncImageCell';
export const FragmentTable = ({ Fragments, client, StreamARN }) => {
    const columns = [
        {
            field: '_image',
            headerName: 'Image?',
            flex: 2,
            renderCell: ({ row }) => _jsx(AsyncImageCell, { params: { row }, client: client, StreamARN: StreamARN, Fragments: Fragments })
        },
        { field: 'FragmentNumber', flex: 2 },
        { field: 'FragmentSizeInBytes', flex: 2 },
        { field: 'ProducerTimestamp', flex: 6 },
        { field: 'ServerTimestamp', flex: 6 },
    ];
    const datagridProps = {
        ...defaultPartialDataGridProps,
        columns,
        rows: Fragments,
        getRowId: (row) => row.FragmentNumber,
        rowCount: 100,
    };
    return _jsx(StripedDataGrid, { ...datagridProps });
};
